import {
  LayoutDesktopCustomHeaderStyled,
  LayoutDesktopHeaderStyled,
} from './LayoutDesktop.styles';
import HostfullyLogo from '@/assets/images/hf-logo-white.png';

const LayoutDesktopHeader = () => {
  // TODO whitelabelling
  const customHeaderContent = undefined;
  const logoUrl = undefined;

  if (customHeaderContent) {
    return (
      <LayoutDesktopCustomHeaderStyled
        dangerouslySetInnerHTML={{ __html: customHeaderContent }}
      />
    );
  }

  return (
    <LayoutDesktopHeaderStyled>
      <div>
        <img
          src={logoUrl || HostfullyLogo}
          alt="Logo"
          width={112}
          height={32}
        />
      </div>
    </LayoutDesktopHeaderStyled>
  );
};

export default LayoutDesktopHeader;
